import { hasModule } from "csi/_base/modules";
import Values from "csi/store/Values";
import xml from "csi/xml";
import Query from "csi/xml/Query";

/** return roles required to configure change tracking */
export function getConfigRoles(): string[] {
	return ["Configuration Editor", "Change Log Administrator"];
}

/** return roles required to view change tracking */
export function getTrackingRoles(): string[] {
	return ["Change Log Viewer", "Change Log Administrator"];
}

/** return types that are being tracked by the change log service */
export async function getTrackingTypes(): Promise<string[]> {
	if (!hasModule("ChangeTracking")) {
		return [];
	}

	const store = new Values({
		filterQuery: new Query().Type("DomainClassConfiguration")
			.Attr("ChangeTrackingEnabled", xml.OP_EQUALS, true),
	});

	try {
		const results = await store.asyncQuery();
		return results.map((item) => store.getIdentity(item));
	} catch (err) {
		return [];
	}
}
